document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(".header__inline-menu .mega-menu").forEach(function(element){
    element.addEventListener('mouseover', () => { 
      element.setAttribute('open', 'true');
    });
 
    element.addEventListener('mouseout', () => {
      element.removeAttribute('open');
    });
  });
});

